import type { CanBuilder, CannotBuilder } from "../types";

export function defineAuthenticatedRules({
	can,
	cannot,
}: {
	can: CanBuilder;
	cannot: CannotBuilder;
}): void {
	cannot("create", "Organization");

	can("read", "Account");
	can("update", "Account");

	can("read", "AIA");
	can("read", "EPS");

	can("read", "Area");
	can("read", "Section");
	can("read", "Question");
}
